<template>
    <vs-col :class="{new_adap_list_discepline:adap,new_adap_list_discepline_mobil:!adap}">
        <div class="vx-card" v-if="cycles.length>0||is_edvisor">
            <div class="vx-card__collapsible-content vs-con-loading__container">
                <div>
                    <div>
                        <transition-group name="list-enter-up" class="email__mails" tag="div" >
                            <ul class="card-border mb-5" style="border: 0.5px solid #cccccc;border-radius: 4px;" :key="discepline.uid" v-for="(discepline, index) in disceplines">
                                <li class="cursor-pointer email__mail-item"
                                    :style="{transitionDelay: (index * 0.1) + 's'}" @click="updateOpenSideBar(index,discepline)" >
                                    <Item :discepline="discepline"  />
                                </li>

                                <li class="cursor-pointer email__mail-item"
                                    v-for="child in discepline.children" :key="child.uid"
                                    :style="{transitionDelay: (index * 0.1) + 's'}" @click="updateOpenSideBar(index,child)" >
                                    <Item :discepline="child" is_child="yes"/>
                                </li>
                            </ul>
                        </transition-group>
                    </div>
                </div>
            </div>
        </div>
    </vs-col>

</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import Item from './Item.vue';
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
    components:{Item,VuePerfectScrollbar },

    computed: {
        is_edvisor() {
            return this.$store.state.user.user.role.is_supervisor;
        },
        ...mapGetters({
            disceplines:'regis_discepline/getListDiscepline',
            cycles: "regis_discepline/getCicle"
        }),
        adap() {
            if (this.$store.state.windowWidth < 992) {
                return false;
            } else {
                return true;
            }
        },
    },

    methods: {
        ...mapMutations({
            openSideBar:'regis_discepline_sidebar/SET_ACTIVITY',
            setDiscepline:'regis_discepline_sidebar/SET_DISCEPLINE',
        }),

        updateOpenSideBar(key,discepline){
            this.openSideBar(true);
            this.setDiscepline({
                key:key,
                discepline:discepline,
            });
        },
    },
}
</script>
<style lang="scss">
    @import "@/assets/scss/vuexy/apps/email.scss";
    .new_adap_list_discepline {
        width: 95% !important;
    }
    .new_adap_list_discepline_mobil {
        width: 90% !important;
    }
</style>
